import { ResolverTag } from '@ps/web-core-enums';
import { translatedLink } from '@ps/web-shared-ui';
import type { ReactNode } from 'react';
import type React from 'react';

import Translation from '../Translation/Translation';
import { useResolver } from '../hooks/useResolver/useResolver';
import {
  TXTWCL_If_you_continue_to_encounter_p_ELL,
  TXTWCL_Please_refresh_your_browser_an_ELL
} from '../translations';

interface Props {
  className?: string;
  title?: ReactNode;
}

const PowMessage: React.FC<Props> = ({ className, title }) => {
  const failedPow = useResolver(ResolverTag.FailedPow);

  const body = (
    <>
      {title} <Translation {...TXTWCL_Please_refresh_your_browser_an_ELL} />{' '}
      <Translation
        {...TXTWCL_If_you_continue_to_encounter_p_ELL}
        values={{
          a: translatedLink({ href: failedPow })
        }}
      />
    </>
  );

  return className ? <p className={className}>{body}</p> : body;
};

export default PowMessage;
